module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "man_1 "
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "man"
  }, [_c('div', {
    staticClass: "man_head"
  }, [_c('Home_Head')], 1), _vm._v(" "), _c('div', {
    staticClass: "man_end"
  }, [_c('div', {
    staticClass: "man_end_1"
  }, [_c('router-view')], 1)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "man_bj"
  }, [_c('img', {
    attrs: {
      "src": require("../../static/images/bg.png")
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-7a12f69c"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/components/man.vue
// module id = 1079
// module chunks = 1